export const LOCAL_LOWDB_NAME = "hearth_local_booking_db";
// Empty string means use current origin (for proxied setup), undefined means use localhost
export const API_BASE_URL = import.meta.env.VITE_API_URL !== undefined
  ? import.meta.env.VITE_API_URL
  : "http://localhost:3000";

// Debug: Log the API base URL on initialization (only in development)
console.log("[API Config] VITE_APP_ENV:", import.meta.env.VITE_APP_ENV);
if (import.meta.env.VITE_APP_ENV !== "production") {
  console.log("[API Config] VITE_API_URL:", import.meta.env.VITE_API_URL);
}

export function parseMockDate(val: string | undefined): Date | undefined {
  const TODAY = new Date(); // October is month 9 (0-indexed)
  const TOMORROW = new Date();
  const DAYAFTERTOMORROW = new Date();
  const DAYPLUSTWO = new Date();

  TOMORROW.setDate(TODAY.getDate() + 1);
  DAYAFTERTOMORROW.setDate(TODAY.getDate() + 2);
  DAYPLUSTWO.setDate(TODAY.getDate() + 3);

  if (!val) return undefined;

  if (val === "today") return new Date(TODAY);
  if (val === "tomorrow") return new Date(TOMORROW);
  if (val === "dayaftertomorrow") return new Date(DAYAFTERTOMORROW);
  if (val === "dayplustwo") return new Date(DAYPLUSTWO);

  // Try to parse as a date string
  const parsed = new Date(val);
  // Check if parsed is a valid date
  if (!isNaN(parsed.getTime())) {
    return parsed;
  }
  return undefined;
}
